import {handleResponse} from "@/services/service-helpers.ts"
import type {CleanupRunResponse, CleanupLogEntry} from "@/models/data-cleanup.ts"

const BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/data-cleanup`

export async function getLatestCleanupRun(
    token: string | null
): Promise<CleanupRunResponse | null> {
    if (!token) {
        return Promise.reject("No token provided")
    }

    const response = await fetch(`${BASE_URL}/latest-run`, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })
    })

    const result = await handleResponse<CleanupRunResponse | null>(response)
    return result ?? null
}

export async function getCleanupLog(
    token: string | null,
    search?: string
): Promise<CleanupLogEntry[]> {
    if (!token) {
        return Promise.reject("No token provided")
    }

    const params = new URLSearchParams()
    if (search?.trim()) {
        params.set('search', search.trim())
    }

    const url = params.toString() ? `${BASE_URL}/log?${params}` : `${BASE_URL}/log`

    const response = await fetch(url, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })
    })

    const result = await handleResponse<CleanupLogEntry[]>(response)
    return result || []
}
